/* eslint-disable max-lines */
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { StylesMap } from 'types/utils';
import { AdaptiveText, AdaptiveTextSize, TypographyProps, Header, Size, Text, UnsizableText } from './typography-types';

export const StyledTypography = styled.p<TypographyProps>`
  margin: 0;
  color: ${({ color }: TypographyProps) => (color ? `var(--${color})` : 'var(--text-primary)')};
`;

export const variantStylesMap: StylesMap<Header & Text & UnsizableText> = {
  display: css`
    font-weight: bold;
    font-size: 48px;
    line-height: 56px;

    @media (--only-mobile) {
      font-size: 34px;
      line-height: 40px;
    }
  `,
  h1: css`
    font-weight: bold;
    font-size: 34px;
    line-height: 40px;
  `,
  h2: css`
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
  `,
  h3: css`
    font-weight: 500;
    font-size: 20px;
    line-height: 26px;
  `,
  l: css`
    font-size: 20px;
  `,
  m: css`
    font-size: 16px;
  `,
  s: css`
    font-size: 14px;
  `,
  caption: css`
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  `,
  caption_accent: css`
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
  `,
  minor_caption: css`
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    opacity: 0.6;
  `,
  overline: css`
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
  `,
};

export const sizeStylesMap: Record<Text, StylesMap<Size>> = {
  l: {
    body_long: css`
      font-weight: 400;
      line-height: 32px;
    `,
    body_short: css`
      font-weight: 400;
      line-height: 28px;
    `,
    body_accent: css`
      font-weight: 500;
      line-height: 32px;
    `,
    subtitle: css`
      font-weight: 500;
      line-height: 28px;
    `,
  },
  m: {
    body_long: css`
      font-weight: 400;
      line-height: 24px;
    `,
    body_short: css`
      font-weight: 400;
      line-height: 22px;
    `,
    body_accent: css`
      font-weight: 500;
      line-height: 24px;
    `,
    subtitle: css`
      font-weight: 500;
      line-height: 22px;
    `,
  },
  s: {
    body_long: css`
      font-weight: 400;
      line-height: 20px;
    `,
    body_short: css`
      font-weight: 400;
      line-height: 18px;
    `,
    body_accent: css`
      font-weight: 500;
      line-height: 20px;
    `,
    subtitle: css`
      font-weight: 500;
      line-height: 18px;
    `,
  },
};

export const adaptiveVariantStylesMap: StylesMap<AdaptiveText> = {
  h1: css`
    @media (--only-mobile) {
      font-size: 28px;
      line-height: 34px;
    }
  `,
  h2: css`
    @media (--only-mobile) {
      font-size: 22px;
      line-height: 28px;
    }
  `,
  h3: css`
    @media (--only-mobile) {
      font-size: 18px;
      line-height: 24px;
    }
  `,
  l: css`
    @media (--only-mobile) {
      font-size: 16px;
    } ;
  `,
  m: css`
    @media (--only-mobile) {
      font-size: 14px;
    }
  `,
};

export const adaptiveSizeStylesMap: Record<AdaptiveTextSize, StylesMap<Size>> = {
  l: {
    body_long: css`
      @media (--only-mobile) {
        line-height: 24px;
      }
    `,
    body_short: css`
      @media (--only-mobile) {
        line-height: 22px;
      }
    `,
    body_accent: css`
      @media (--only-mobile) {
        line-height: 24px;
      }
    `,
    subtitle: css`
      @media (--only-mobile) {
        line-height: 22px;
      }
    `,
  },
  m: {
    body_long: css`
      @media (--only-mobile) {
        line-height: 20px;
      }
    `,
    body_short: css`
      @media (--only-mobile) {
        line-height: 18px;
      }
    `,
    body_accent: css`
      @media (--only-mobile) {
        line-height: 20px;
      }
    `,
    subtitle: css`
      @media (--only-mobile) {
        line-height: 18px;
      }
    `,
  },
};
